var React = require('react');

function Circular (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14","cy":"14","r":"13","stroke":"url(#paint0_linear)","strokeWidth":"2","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"14","y1":"0","x2":"14","y2":"28","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#2940EC","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#EF9C94","key":1})]))]);
}

Circular.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Circular;

Circular.default = Circular;
